export default class LocationFilter {
    constructor(transliterator, locationConfigStorage) {
        this.transliterator = transliterator;
        this.locationConfigStorage = locationConfigStorage;
    }

    filterMatchingLocations(filter) {
        return this.locationConfigStorage.getLocationConfig().locations
            .filter((location) => { return this.locationMatchesFilter(location, filter); });
    }

    locationMatchesFilter(location, filter) {
        let text = null;
        if (angular.isString(filter.text) && filter.text !== '') {
            text = this.transliterator.transliterate(filter.text).toLowerCase();
        }

        return ((
            !text
            || location.transliterated.title.indexOf(text) !== -1
            || location.transliterated.description.indexOf(text) !== -1
            || location.transliterated.address.indexOf(text) !== -1
        )
        && (
            this.arrayIntersect(location.services, filter.services).length > 0
            || this.belongsToRootCategory(location.pay_categories, filter.payCategories)
        ));
    }

    belongsToRootCategory(subCategories, filteredRootCategories) {
        var rootCategories = [];
        angular.forEach(subCategories, (categoryId) => {
            angular.forEach(this.locationConfigStorage.getLocationConfig().pay_categories, (mainCategory) => {
                if (mainCategory.id === categoryId) {
                    if (mainCategory.hasOwnProperty('root_id')) {
                        rootCategories.push(mainCategory.root_id);
                    } else {
                        rootCategories.push(mainCategory.id);
                    }
                }
            })
        });

        var filteredRootCategoryIds = filteredRootCategories
            .map((rootCategory) => { return rootCategory.id; })
        ;

        return this.arrayIntersect(rootCategories, filteredRootCategoryIds).length > 0;
    }

    arrayIntersect(array1, array2) {
        return array1.filter((el) => { return array2.indexOf(el) !== -1; });
    }
}

LocationFilter.$inject = ['transliterator', 'locationConfigStorage'];
